import React from 'react';
import { motion } from 'framer-motion';
import { Award, BookOpen, Globe, Users, PenLine } from 'lucide-react';

const highlights = [
  { icon: Award, title: 'Best-Selling Author', description: 'Amazon best-seller with YA novel I Am Cecilia' },
  { icon: Users, title: 'National Recognition', description: 'Endorsed by National Writers Union, listed in Who\'s Who in America and World' },
  { icon: BookOpen, title: 'Literary Publications', description: 'Published in Tint, Synchronized Chaos, and multiple anthologies' },
  { icon: PenLine, title: 'Ghostwriter', description: 'Ghostwriter for Forbes Books and KN Literary' },
  { icon: Globe, title: 'International Experience', description: 'Lived and studied in Prague, London, and Washington DC' },
];

const AccomplishmentCard = ({ item, index }) => {
  const Icon = item.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1, duration: 0.6 }}
      className="text-center"
      data-testid={`accomplishment-${index}`}
    >
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white border-2 border-pink-blush mb-6 shadow-soft">
        <Icon className="w-8 h-8 text-pink-mauve" />
      </div>
      <h3 className="text-xl font-serif font-semibold text-brown-deep mb-3">{item.title}</h3>
      <p className="text-base leading-relaxed text-brown-warm">{item.description}</p>
    </motion.div>
  );
};

const Accomplishments = () => (
  <section className="py-24 md:py-32 bg-gradient-to-b from-pink-soft/30 to-beige-light px-6 md:px-12 lg:px-24 relative overflow-hidden">
    <img
      src="https://static.prod-images.emergentagent.com/jobs/01684d0c-4acd-465a-8f1a-34b32ab7bf23/images/26e3376bce1799d8ec591d8c0a7dc9b7ff03257ee9e71c11b88f5ff3a7f80066.png"
      alt=""
      className="absolute top-10 right-10 w-24 h-24 opacity-20 animate-float pointer-events-none"
    />

    <div className="max-w-7xl mx-auto relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <p className="text-sm tracking-widest uppercase text-pink-deep font-sans mb-4">Recognition</p>
        <h2 className="text-4xl md:text-5xl font-serif font-semibold tracking-tight text-brown-deep" data-testid="accomplishments-title">
          Achievements & Honors
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
        {highlights.map((item, index) => (
          <AccomplishmentCard key={item.title} item={item} index={index} />
        ))}
      </div>
    </div>
  </section>
);

export default Accomplishments;
